export default __webpack_public_path__ + "static/media/mypicture-light.5f37b823.png";